import React from 'react';
import { FileText, CheckCircle, Hash, Folder } from 'lucide-react';
import { Template } from './types';

interface TemplateStatsProps {
    templates: Template[];
}

const TemplateStats: React.FC<TemplateStatsProps> = ({ templates }) => {
    const totalTemplates = templates.length;
    const activeTemplates = templates.filter((t) => t.is_active).length;
    const totalKeys = templates.reduce((sum, t) => sum + (t.Keys?.length || 0), 0);
    const totalSizeKB = Math.round(
        templates.reduce((sum, t) => sum + t.file_size, 0) / 1024
    );

    return (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
                <div className="flex items-center">
                    <div className="bg-blue-100 p-3 rounded-lg">
                        <FileText className="h-6 w-6 text-blue-600" />
                    </div>
                    <div className="ml-4">
                        <p className="text-sm font-medium text-gray-600">Toplam Şablon</p>
                        <p className="text-2xl font-bold text-gray-900">{totalTemplates}</p>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
                <div className="flex items-center">
                    <div className="bg-green-100 p-3 rounded-lg">
                        <CheckCircle className="h-6 w-6 text-green-600" />
                    </div>
                    <div className="ml-4">
                        <p className="text-sm font-medium text-gray-600">Aktif Şablon</p>
                        <p className="text-2xl font-bold text-gray-900">{activeTemplates}</p>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
                <div className="flex items-center">
                    <div className="bg-purple-100 p-3 rounded-lg">
                        <Hash className="h-6 w-6 text-purple-600" />
                    </div>
                    <div className="ml-4">
                        <p className="text-sm font-medium text-gray-600">Toplam Key</p>
                        <p className="text-2xl font-bold text-gray-900">{totalKeys}</p>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
                <div className="flex items-center">
                    <div className="bg-orange-100 p-3 rounded-lg">
                        <Folder className="h-6 w-6 text-orange-600" />
                    </div>
                    <div className="ml-4">
                        <p className="text-sm font-medium text-gray-600">Toplam Boyut</p>
                        <p className="text-2xl font-bold text-gray-900">{totalSizeKB} KB</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TemplateStats;
